import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface SummarySelectProps {
  title: string;
  conclusion: string;
  details?: string;
  selected?: boolean;
  type: string;
  selectChange?: (type: string, checked: boolean) => void;
  variant?: 'lightPurple' | 'green' | 'blue';
  className?: string;
  userQuestion?: string;
}

const SummarySelect: React.FC<SummarySelectProps> = ({
  title,
  conclusion,
  details,
  type,
  selected,
  selectChange,
  variant = 'lightPurple',
  className,
  userQuestion
}) => {
  const navigate = useNavigate();
  // 根据变体选择不同的样式
  const getVariantStyles = () => {
    switch (variant) {
      case 'green':
        return {
          container: 'bg-gradient-to-b from-[#EBFDFA] to-[#F3FFFD]',
          detailsBg: 'bg-[#D2F0EB]'
        };
      case 'blue':
        return {
          container: 'bg-gradient-to-b from-[#D1E7FF] to-[#EBF4FF]',
          detailsBg: 'bg-blue-100/40'
        };
      default: // purple
        return {
          container: 'bg-gradient-to-b from-[#EEEDFF] to-[#F6F7FF]',
          detailsBg: 'bg-[rgba(202,208,251,0.4)]'
        };
    }
  };
  const toHomePage = (conclusion: string, userQuestion: string) => {
    console.log(conclusion, 'conclusion');
    navigate('/#', { state: { scjdonclusion: conclusion, userQuestion: userQuestion } });
  };

  const styles = getVariantStyles();
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  useEffect(() => {
    setCheckboxChecked(selected);
  }, [selected]);
  const handleCheckboxChange = (checked: boolean) => {
    setCheckboxChecked(checked);
    selectChange?.(type, checked);
  };
  return (
    <div className="relative rounded-lg bg-white p-[2px]">
      <div className={cn('gradient-border-box absolute inset-0 p-[1px]', className)}>
        <div className="h-full w-full rounded-lg bg-white"></div>
      </div>
      <div className={`${styles.container} relative z-10 rounded-lg p-3 ${className}`}>
        {/* 标题行 */}
        <div className="mb-1.5 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="custom-checkbox">
              <input
                type="checkbox"
                checked={checkboxChecked}
                onChange={e => handleCheckboxChange(e.target.checked)}
                className="h-4 w-4"
                id={`customcheckbox${type + title || '' + conclusion || '' + Math.random()}`}
              />
              <label
                htmlFor={`customcheckbox${type + title || '' + conclusion || '' + Math.random()}`}
              />
            </div>
            <span className="text-base font-semibold text-gray-900">{title}</span>
          </div>
          <div className="cursor-pointer" onClick={() => toHomePage(conclusion, userQuestion)}>
            <ArrowRight size={16} />
          </div>
        </div>

        {/* 结论与建议 */}
        <p className="mb-1.5 text-left text-xs leading-relaxed text-gray-900">{conclusion}</p>

        {/* 详细信息 */}
        {details && (
          <div className={`${styles.detailsBg} rounded-md p-1`}>
            <p className="whitespace-pre-line px-2 text-xs leading-relaxed text-gray-900">
              {details}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SummarySelect;
